import NVB_1 from "../../assets/icon/Viettel post.png";
import NVB_2 from "../../assets/icon/Xanhpon.png";
import NVB_3 from "../../assets/icon/Thanhnhan.png";
import NVB_4 from "../../assets/icon/DVC quoc gia.png";
import NVB_5 from "../../assets/icon/DVC quoc gia-1.png";
import NVB_6 from "../../assets/icon/DVC quoc gia-2.png";
import NVB_7 from "../../assets/icon/NVB-3.png";

export const typicalPartners = [NVB_1, NVB_2, NVB_3, NVB_4, NVB_7, NVB_5, NVB_6];
